<div class="bg-white/40 dark:bg-dark/10 rounded-3xl">
  <div class="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between p-4">
    <div>
      <h1 class="text-base font-semibold text-black dark:text-white">{{ pageTitle }}</h1>
      <p class="text-sm text-gray-500 dark:text-white-dark">{{ pageSubtitle }}</p>
    </div>
    @if (!loading && !loadError) {
    @if (!hasOrganization && !editMode && (P.ORGANIZATION_DETAILS_UPDATE | hasPermission)) {
    <button type="button"
      class="btn bg-white text-black hover:bg-[#303030] hover:text-white inline-flex items-center gap-2 py-3 px-4 rounded-full shadow-none"
      (click)="startAdd()">
      <icon-plus class="h-4 w-4" />
      Add
    </button>
    } @else if (hasOrganization && !editMode && (P.ORGANIZATION_DETAILS_UPDATE | hasPermission)) {
    <button type="button"
      class="btn bg-white text-black hover:bg-[#303030] hover:text-white inline-flex items-center gap-2 py-3 px-4 rounded-full shadow-none"
      (click)="startEdit()">
      <icon-edit class="h-4 w-4" />
      Edit
    </button>
    } @else if (editMode) {
    <button type="button"
      class="btn bg-white text-black hover:bg-[#303030] hover:text-white inline-flex items-center gap-2 py-3 px-4 rounded-full shadow-none"
      (click)="cancelEdit()" [disabled]="saving">
      Cancel
    </button>
    }
    }
  </div>

  <div class="rounded-3xl border border-white-light/80 bg-white p-4 shadow-sm dark:border-[#191e3a] dark:bg-[#0e1726]">
    @if (loadError) {
    <div class="mb-3 flex flex-wrap items-center gap-2 text-sm text-danger">
      <span>{{ loadError }}</span>
      <button type="button" class="btn btn-sm rounded-full px-3 py-1" (click)="loadOrganization()">
        Retry
      </button>
    </div>
    }


    @if (loading) {
    <p class="text-sm text-gray-500 dark:text-white-dark">Loading organization details…</p>
    } @else if (!loadError && !editMode && hasOrganization && (P.ORGANIZATION_DETAILS_LIST | hasPermission)) {
    <div class="grid grid-cols-1 gap-6 md:grid-cols-3">
      @if (organization?.logo_url) {
      <div class="md:col-span-3">
        <img [src]="organization?.logo_url" alt="Organization logo" class="h-14 max-w-[10rem] object-contain" />
      </div>
      }
      <div>
        <p class="text-xs font-medium text-gray-500 dark:text-white-dark">Organization name</p>
        <p class="mt-1 text-base font-bold text-black dark:text-white">
          {{ display(organization?.organization_name) }}
        </p>
      </div>
      <div>
        <p class="text-xs font-medium text-gray-500 dark:text-white-dark">Legal name</p>
        <p class="mt-1 text-base font-bold text-black dark:text-white">
          {{ display(organization?.legal_name) }}
        </p>
      </div>
      <div>
        <p class="text-xs font-medium text-gray-500 dark:text-white-dark">GST number</p>
        <p class="mt-1 text-base font-bold text-black dark:text-white">
          {{ display(organization?.gst_no) }}
        </p>
      </div>
      <div>
        <p class="text-xs font-medium text-gray-500 dark:text-white-dark">PAN number</p>
        <p class="mt-1 text-base font-bold text-black dark:text-white">
          {{ display(organization?.pan_no) }}
        </p>
      </div>
      <div>
        <p class="text-xs font-medium text-gray-500 dark:text-white-dark">Phone Number</p>
        <p class="mt-1 text-base font-bold text-black dark:text-white">
          {{ displayPhone(organization) }}
        </p>
      </div>
      <div>
        <p class="text-xs font-medium text-gray-500 dark:text-white-dark">Email ID</p>
        <p class="mt-1 text-base font-bold text-black dark:text-white">
          {{ display(organization?.email) }}
        </p>
      </div>
      <div>
        <p class="text-xs font-medium text-gray-500 dark:text-white-dark">Street address</p>
        <p class="mt-1 text-base font-bold text-black dark:text-white">
          {{ display(organization?.address) }}
        </p>
      </div>
      <div>
        <p class="text-xs font-medium text-gray-500 dark:text-white-dark">City</p>
        <p class="mt-1 text-base font-bold text-black dark:text-white">
          {{ display(organization?.city) }}
        </p>
      </div>
      <div>
        <p class="text-xs font-medium text-gray-500 dark:text-white-dark">Country</p>
        <p class="mt-1 text-base font-bold text-black dark:text-white">
          {{ display(organization?.country) }}
        </p>
      </div>
      <div>
        <p class="text-xs font-medium text-gray-500 dark:text-white-dark">PIN code</p>
        <p class="mt-1 text-base font-bold text-black dark:text-white">
          {{ display(organization?.pincode) }}
        </p>
      </div>
      <div>
        <p class="text-xs font-medium text-gray-500 dark:text-white-dark">Bank</p>
        <p class="mt-1 text-base font-bold text-black dark:text-white">
          {{ display(organization?.bank_name) }}
        </p>
      </div>
      <div>
        <p class="text-xs font-medium text-gray-500 dark:text-white-dark">Account name</p>
        <p class="mt-1 text-base font-bold text-black dark:text-white">
          {{ display(organization?.bank_account_name) }}
        </p>
      </div>
      <div>
        <p class="text-xs font-medium text-gray-500 dark:text-white-dark">Account number</p>
        <p class="mt-1 text-base font-bold text-black dark:text-white">
          {{ display(organization?.bank_account_number) }}
        </p>
      </div>
      <div>
        <p class="text-xs font-medium text-gray-500 dark:text-white-dark">IFSC</p>
        <p class="mt-1 text-base font-bold text-black dark:text-white">
          {{ display(organization?.bank_ifsc) }}
        </p>
      </div>
      <div>
        <p class="text-xs font-medium text-gray-500 dark:text-white-dark">UPI ID</p>
        <p class="mt-1 text-base font-bold text-black dark:text-white">
          {{ display(organization?.upi_id) }}
        </p>
      </div>
      <div>
        <p class="text-xs font-medium text-gray-500 dark:text-white-dark">HSN/SAC code</p>
        <p class="mt-1 text-base font-bold text-black dark:text-white">
          {{ display(organization?.sac_code) }}
        </p>
      </div>
      <div>
        <p class="text-xs font-medium text-gray-500 dark:text-white-dark">Payment terms</p>
        <p class="mt-1 text-base font-bold text-black dark:text-white">
          {{ (organization?.payment_terms_days ?? 15) + ' days' }}
        </p>
      </div>
    </div>
    } @else if (!loadError && !editMode && !hasOrganization && (P.ORGANIZATION_DETAILS_LIST | hasPermission)) {
    <div class="py-8 text-center">
      <p class="text-sm text-gray-500 dark:text-white-dark">
        @if (P.ORGANIZATION_DETAILS_UPDATE | hasPermission) {
        No organization details yet. Click <span class="font-semibold text-black dark:text-white">Add</span> to create
        your organization profile.
        } @else {
        No organization details yet.
        }
      </p>
    </div>
    } @else if (!loading && !loadError && !editMode && !(P.ORGANIZATION_DETAILS_LIST | hasPermission) && !(P.ORGANIZATION_DETAILS_UPDATE | hasPermission)) {
    <div class="py-8 text-center">
      <p class="text-sm text-gray-500 dark:text-white-dark">
        You do not have permission to view organization details.
      </p>
    </div>
    } @else if (editMode && (P.ORGANIZATION_DETAILS_UPDATE | hasPermission)) {
    <p class="mb-4 text-xs text-gray-500 dark:text-gray-400">
      <span class="font-semibold text-red-600" aria-hidden="true">*</span> Required field
    </p>
    <form class="grid grid-cols-1 gap-5 md:grid-cols-2" (ngSubmit)="submit($event)">
      <div>
        <label class="mb-1 block text-xs font-medium text-gray-500 dark:text-white-dark" for="org-name">
          Organization name <span class="font-semibold text-red-600" aria-hidden="true">*</span>
        </label>
        <input id="org-name" type="text" class="form-input" [(ngModel)]="form.organization_name"
          (ngModelChange)="clearFieldError('organization_name')" name="orgName" required aria-required="true" />
        @if (fieldError('organization_name')) {
        <p class="mt-1 text-xs text-danger">{{ fieldError('organization_name') }}</p>
        }
      </div>
      <div>
        <label class="mb-1 block text-xs font-medium text-gray-500 dark:text-white-dark" for="org-legal">
          Legal name <span class="font-semibold text-red-600" aria-hidden="true">*</span>
        </label>
        <input id="org-legal" type="text" class="form-input" [(ngModel)]="form.legal_name"
          (ngModelChange)="clearFieldError('legal_name')" name="orgLegal" required aria-required="true" />
        @if (fieldError('legal_name')) {
        <p class="mt-1 text-xs text-danger">{{ fieldError('legal_name') }}</p>
        }
      </div>
      <div>
        <label class="mb-1 block text-xs font-medium text-gray-500 dark:text-white-dark" for="org-pan">
          PAN number <span class="font-semibold text-red-600" aria-hidden="true">*</span>
        </label>
        <input id="org-pan" type="text" class="form-input" [(ngModel)]="form.pan_no"
          (ngModelChange)="clearFieldError('pan_no')" name="orgPan" required aria-required="true" />
        @if (fieldError('pan_no')) {
        <p class="mt-1 text-xs text-danger">{{ fieldError('pan_no') }}</p>
        }
      </div>
      <div>
        <label class="mb-1 block text-xs font-medium text-gray-500 dark:text-white-dark" for="org-gst">
          GST number <span class="font-semibold text-red-600" aria-hidden="true">*</span>
        </label>
        <input
          id="org-gst"
          type="text"
          class="form-input"
          [(ngModel)]="form.gst_no"
          (ngModelChange)="clearFieldError('gst_no')"
          name="orgGst"
          required
          aria-required="true"
        />
        @if (fieldError('gst_no')) {
        <p class="mt-1 text-xs text-danger">{{ fieldError('gst_no') }}</p>
        }
      </div>

      <div>
        <app-intl-phone-field label="Phone Number" inputId="orgPhone" name="orgPhone" placeholder="Enter phone number"
          [required]="true" [(countryIso)]="phoneIso" [(nationalNumber)]="phoneNational"
          (countryIsoChange)="onPhoneNationalChange()"
          (nationalNumberChange)="onPhoneNationalChange()"></app-intl-phone-field>
        @if (phoneError) {
        <p class="mt-1 text-xs text-danger">{{ phoneError }}</p>
        }
      </div>
      <div>
        <label class="mb-1 block text-xs font-medium text-gray-500 dark:text-white-dark" for="org-email">
          Email ID <span class="font-semibold text-red-600" aria-hidden="true">*</span>
        </label>
        <input id="org-email" type="email" class="form-input" [(ngModel)]="form.email"
          (ngModelChange)="clearFieldError('email')" name="orgEmail" required aria-required="true" />
        @if (fieldError('email')) {
        <p class="mt-1 text-xs text-danger">{{ fieldError('email') }}</p>
        }
      </div>
      <div class="md:col-span-2">
        <label class="mb-1 block text-xs font-medium text-gray-500 dark:text-white-dark" for="org-address">
          Street address <span class="font-semibold text-red-600" aria-hidden="true">*</span>
        </label>
        <input id="org-address" type="text" class="form-input" [(ngModel)]="form.address"
          (ngModelChange)="clearFieldError('address')" name="orgAddress" required aria-required="true" />
        @if (fieldError('address')) {
        <p class="mt-1 text-xs text-danger">{{ fieldError('address') }}</p>
        }
      </div>
      <div>
        <label class="mb-1 block text-xs font-medium text-gray-500 dark:text-white-dark" for="org-city">
          City <span class="font-semibold text-red-600" aria-hidden="true">*</span>
        </label>
        <input id="org-city" type="text" class="form-input" [(ngModel)]="form.city"
          (ngModelChange)="clearFieldError('city')" name="orgCity" required aria-required="true" />
        @if (fieldError('city')) {
        <p class="mt-1 text-xs text-danger">{{ fieldError('city') }}</p>
        }
      </div>
      <div>
        <label class="mb-1 block text-xs font-medium text-gray-500 dark:text-white-dark" for="org-country">
          Country <span class="font-semibold text-red-600" aria-hidden="true">*</span>
        </label>
        <input id="org-country" type="text" class="form-input" [(ngModel)]="form.country"
          (ngModelChange)="clearFieldError('country')" name="orgCountry" required aria-required="true" />
        @if (fieldError('country')) {
        <p class="mt-1 text-xs text-danger">{{ fieldError('country') }}</p>
        }
      </div>
      <div>
        <label class="mb-1 block text-xs font-medium text-gray-500 dark:text-white-dark" for="org-pincode">
          PIN code <span class="font-semibold text-red-600" aria-hidden="true">*</span>
        </label>
        <input id="org-pincode" type="text" class="form-input" [(ngModel)]="form.pincode"
          (ngModelChange)="clearFieldError('pincode')" name="orgPincode" required aria-required="true" />
        @if (fieldError('pincode')) {
        <p class="mt-1 text-xs text-danger">{{ fieldError('pincode') }}</p>
        }
      </div>
      <div class="md:col-span-2">
        <span class="mb-1 block text-xs font-medium text-gray-500 dark:text-white-dark">Organization logo</span>
        <div class="flex min-w-0 flex-wrap items-center gap-3">
          <label
            class="inline-flex cursor-pointer items-center gap-2 rounded-lg bg-[#FFD85F] px-4 py-1 mb-0 text-xs font-semibold text-black transition hover:opacity-90">
            Upload logo
            <input type="file" [accept]="logoAccept" class="sr-only" (change)="onLogoSelected($event)" />
          </label>
          @if (currentLogoUrl) {
          <img [src]="currentLogoUrl" alt="Organization logo"
            class="h-16 w-44 shrink-0 rounded-xl border border-gray-200 bg-white object-contain dark:border-[#191e3a] dark:bg-[#0e1726]" />
          <button type="button"
            class="btn rounded-lg border border-danger px-3 py-1.5 text-xs font-semibold text-danger hover:bg-danger/10 disabled:opacity-50"
            (click)="removeLogo()" [disabled]="saving">
            Remove logo
          </button>
          }
        </div>
        <p class="mt-1 text-xs text-gray-500 dark:text-white-dark">PNG, JPEG, WebP or SVG, up to 2 MB</p>
        @if (logoError) {
        <p class="mt-1 text-xs text-danger">{{ logoError }}</p>
        }
      </div>
      <div class="md:col-span-2">
        <h2 class="text-sm font-semibold text-black dark:text-white">Bank &amp; payment details (optional)</h2>
      </div>
      <div>
        <label class="mb-1 block text-xs font-medium text-gray-500 dark:text-white-dark" for="org-bank-name">
          Bank name
        </label>
        <input id="org-bank-name" type="text" class="form-input" [(ngModel)]="form.bank_name"
          (ngModelChange)="clearFieldError('bank_name')" name="orgBankName" />
        @if (fieldError('bank_name')) {
        <p class="mt-1 text-xs text-danger">{{ fieldError('bank_name') }}</p>
        }
      </div>
      <div>
        <label class="mb-1 block text-xs font-medium text-gray-500 dark:text-white-dark" for="org-bank-account-name">
          Account name
        </label>
        <input id="org-bank-account-name" type="text" class="form-input" [(ngModel)]="form.bank_account_name"
          (ngModelChange)="clearFieldError('bank_account_name')" name="orgBankAccountName" />
        @if (fieldError('bank_account_name')) {
        <p class="mt-1 text-xs text-danger">{{ fieldError('bank_account_name') }}</p>
        }
      </div>
      <div>
        <label class="mb-1 block text-xs font-medium text-gray-500 dark:text-white-dark" for="org-bank-account-number">
          Account number
        </label>
        <input id="org-bank-account-number" type="text" inputmode="numeric" class="form-input" [(ngModel)]="form.bank_account_number"
          (ngModelChange)="clearFieldError('bank_account_number')" name="orgBankAccountNumber" />
        @if (fieldError('bank_account_number')) {
        <p class="mt-1 text-xs text-danger">{{ fieldError('bank_account_number') }}</p>
        }
      </div>
      <div>
        <label class="mb-1 block text-xs font-medium text-gray-500 dark:text-white-dark" for="org-bank-ifsc">
          IFSC
        </label>
        <input id="org-bank-ifsc" type="text" class="form-input" [(ngModel)]="form.bank_ifsc"
          (ngModelChange)="clearFieldError('bank_ifsc')" name="orgBankIfsc" />
        @if (fieldError('bank_ifsc')) {
        <p class="mt-1 text-xs text-danger">{{ fieldError('bank_ifsc') }}</p>
        }
      </div>
      <div>
        <label class="mb-1 block text-xs font-medium text-gray-500 dark:text-white-dark" for="org-upi-id">
          UPI ID
        </label>
        <input id="org-upi-id" type="text" class="form-input" [(ngModel)]="form.upi_id"
          (ngModelChange)="clearFieldError('upi_id')" name="orgUpiId" />
        @if (fieldError('upi_id')) {
        <p class="mt-1 text-xs text-danger">{{ fieldError('upi_id') }}</p>
        }
      </div>
      <div>
        <label class="mb-1 block text-xs font-medium text-gray-500 dark:text-white-dark" for="org-sac-code">
          HSN/SAC code
        </label>
        <input id="org-sac-code" type="text" class="form-input" [(ngModel)]="form.sac_code" maxlength="8"
          (ngModelChange)="clearFieldError('sac_code')" name="orgSacCode" />
        @if (fieldError('sac_code')) {
        <p class="mt-1 text-xs text-danger">{{ fieldError('sac_code') }}</p>
        }
      </div>
      <div>
        <label class="mb-1 block text-xs font-medium text-gray-500 dark:text-white-dark" for="org-payment-terms">
          Payment terms (days)
        </label>
        <input id="org-payment-terms" type="number" min="0" max="120" class="form-input" [(ngModel)]="form.payment_terms_days"
          (ngModelChange)="clearFieldError('payment_terms_days')" name="orgPaymentTerms" />
        @if (fieldError('payment_terms_days')) {
        <p class="mt-1 text-xs text-danger">{{ fieldError('payment_terms_days') }}</p>
        }
      </div>
      <div class="md:col-span-2">
        @if (saveError) {
        <p class="mb-3 text-sm text-danger">{{ saveError }}</p>
        }
        <button type="submit" [disabled]="saving"
          class="btn rounded-full bg-[#303030] px-8 font-semibold text-white shadow-lg disabled:opacity-50">
          {{ saving ? 'Saving...' : (hasOrganization ? 'Save changes' : 'Add organization') }}
        </button>
      </div>
    </form>
    }
  </div>
</div>